// import { Progress } from "antd";
import logo from "../../Assets/images/logo.svg";
import Progress from "../Progress";
import Actions from "./Actions";

const Navbar = ({
  progress = 0,
  project,
  showCart,
  showHelp,
  showProgress = true,
  showProfile,
  tracer,
  title,
  step,
  stepCount,
}) => {
  const parsed = parseInt(progress);
  return (
    <>
      <div className="navbar__wrapper">
        <div className="navbar__wrapper--row">
          <div className="navbar__wrapper--row__icon">
            <div className="navbar__wrapper--row__icon--image">
              <img src={logo} alt="" />
            </div>
          </div>
          <div className="navbar__wrapper--row__content">
            {showProgress && (
              <>
                <div className="navbar__wrapper--row__content--indicator">
                  <span>
                    Étape {step} sur {stepCount} | {title}
                  </span>
                  <span>{parsed}%</span>
                </div>
                <Progress value={parsed} />
              </>
            )}
          </div>
          <div className="navbar__wrapper--actions">
            <Actions
              project={project}
              showCart={showCart}
              showHelp={showHelp}
              showProfile={showProfile}
              tracer={tracer}
            />
          </div>
        </div>
      </div>
    </>
  );
};

Navbar.propTypes = {};

export default Navbar;
